import { Button, Checkbox } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/shared/ui/atoms';
import type { NotificationEnrollmentStatus } from '../../../types/notification';

export interface EnrollmentStatusFiltersProps {
  readonly statuses: readonly NotificationEnrollmentStatus[];
  readonly selectedIds: readonly string[];
  readonly onToggle: (id: string) => void;
  readonly onSelectAll: () => void;
  readonly isLoading?: boolean;
}

/**
 * Filtros de status de matrícula em grade de duas colunas com seleção total.
 */
export function EnrollmentStatusFilters({
  statuses,
  selectedIds,
  onToggle,
  onSelectAll,
  isLoading = false,
}: EnrollmentStatusFiltersProps) {
  const { t } = useTranslation('notification');
  const allSelected = statuses.length > 0 && selectedIds.length === statuses.length;

  return (
    <div className="flex flex-col border-hairline border-ctx-layout-border rounded-md">
      <div className="flex items-center justify-between px-xxs py-micro border-b-hairline border-ctx-layout-border ">
        <span className="ts-subtitle-xs text-ctx-content-title">
          {t('wizard.audience.enrollmentStatus')}
        </span>
        <Button hierarchy="secondary" size="sm" onClick={onSelectAll}>
          {allSelected ? t('wizard.audience.clearSelection') : t('wizard.audience.selectAll')}
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-mini px-xxs py-micro">
        {isLoading
          ? Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="flex items-center gap-nano">
                <Skeleton className="size-[16px] shrink-0" />
                <Skeleton className="h-[14px] flex-1" />
              </div>
            ))
          : statuses.map(status => (
              <Checkbox
                key={status.id}
                checked={selectedIds.includes(status.id)}
                onCheckedChange={() => onToggle(status.id)}
                label={status.label}
                size="sm"
              />
            ))}
      </div>
    </div>
  );
}
